import React from 'react';
import PropTypes from 'prop-types';
import { AlertCircle, ListTodo } from 'lucide-react';
import { Button } from '../../../../../components/ui/button';

function ErrorsModal({ isOpen, onClose, errors, setIsDialogOpened }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div className="fixed inset-0 bg-black/50" onClick={onClose} />

      {/* Modal */}
      <div
        className="relative bg-background rounded-lg shadow-lg p-6 w-full max-w-lg mx-4"
        style={{ border: '1px solid hsl(var(--border))' }}
      >
        <div className="flex items-start gap-4">
          <div className="p-2 rounded-full bg-destructive/10">
            <AlertCircle className="h-5 w-5 text-destructive" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-foreground">Import Errors</h3>
            <p className="mt-2 text-sm text-muted-foreground">
              The following errors occurred during import:
            </p>
          </div>
        </div>

        {/* Errors List */}
        <div className="mt-4 max-h-64 overflow-y-auto space-y-2">
          {errors.map((error, index) => (
            <div
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              className="p-3 rounded-md bg-destructive/10 text-sm text-destructive"
            >
              {error}
            </div>
          ))}
        </div>

        <div className="flex justify-between gap-3 mt-6">
          <Button
            variant="outline"
            onClick={() => {
              onClose();
              setIsDialogOpened(true);
            }}
          >
            <ListTodo className="h-4 w-4 mr-2" />
            Import Default Tasks
          </Button>
          <Button onClick={onClose}>Close</Button>
        </div>
      </div>
    </div>
  );
}

ErrorsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  errors: PropTypes.arrayOf(PropTypes.string).isRequired,
  setIsDialogOpened: PropTypes.func.isRequired,
};

export default ErrorsModal;
